import { APP_CONFIG } from "../config";
const urljoin = require('url-join');
export const BASE_URL = APP_CONFIG.server.uri;
console.log("base url ", BASE_URL)
const api_v1 = "v1.0";
export const API_URL = {

    // AUTH
    AUTH_REGISTER: urljoin(BASE_URL, api_v1, `/user/register`),
    AUTH_LOGIN: urljoin(BASE_URL, api_v1, `/user/login`),
    USER_PROFILE: urljoin(BASE_URL, api_v1, `/user/profile`),

    // USER SUBSCRIPTION
    GET_USERLIST: urljoin(BASE_URL, api_v1, `/user`),
    GET_SUBSCRIPTION: urljoin(BASE_URL, api_v1, `/user/subscriptions`),
    ADD_SUBSCRIPTION: urljoin(BASE_URL, api_v1, `/user/subscriptions/subscribe`),
    REMOVE_SUBSCRIPTION: (subscription_id) => urljoin(BASE_URL, api_v1, `/user/subscriptions/${subscription_id}/unsubsribe`),

    // USER MEMBERSHIP
    MY_MEMBERSHIP: urljoin(BASE_URL, api_v1, `/membership`),
    MY_PLANS: urljoin(BASE_URL, api_v1, `/membership/plans`),
    BUY_MEMBERSHIP: urljoin(BASE_URL, api_v1, `/membership/buy`),

    // GRIEVANCE
    GRIEVANCE: urljoin(BASE_URL, api_v1, `/grievance`),


    // BULLETIN
    BULLETIN: urljoin(BASE_URL, api_v1, `/bulletin`),

    // UPLOAD FILE
    UPLOAD_FILE: urljoin(BASE_URL, api_v1, `/file-store`),

    // NEWS
    LATEST_NEWS: urljoin(BASE_URL, api_v1, `/news`),

    // PAYMENT
    PAYMENT: urljoin(BASE_URL, api_v1, `/payment/pay`),

    // MEMBERS
    MEMBERS: urljoin(BASE_URL, api_v1, `/user/icpa-members`),

    // DOCUMENTS
    DOCUMENTS: {
        LETTER: urljoin(BASE_URL, api_v1, `/document/letter`),
        CIRCULAR: urljoin(BASE_URL, api_v1, `/document/circular`),
        DIRECTIVE: urljoin(BASE_URL, api_v1, `/document/directive`),
        FLIGHT_SAFETY: urljoin(BASE_URL, api_v1, `/document/flight-safety`),
        MISCELLANEOUS: urljoin(BASE_URL, api_v1, `/document/miscellaneous`),
    },

    // SCHEMES
    SCHEMES: {
        TMU: urljoin(BASE_URL, api_v1, `/scheme/tmu`),
        PMU: urljoin(BASE_URL, api_v1, `/scheme/pmu`),
        INCIDENT: urljoin(BASE_URL, api_v1, `/scheme/incident`),
        ACCIDENT: urljoin(BASE_URL, api_v1, `/scheme/accident`),
        ADMIN: urljoin(BASE_URL, api_v1, `/scheme/admin`),
        GET_GMCINDI_PDF: urljoin(BASE_URL, api_v1, `/policy/___administrator/gmc/report`),
        GET_GMC_ALL: urljoin(BASE_URL, api_v1, `/policy/___administrator/gmc`),
        GET_ALL: urljoin(BASE_URL, api_v1, `/scheme`),
        GET_MY_SCHEME: urljoin(BASE_URL, api_v1, `/scheme`),
        GET_GMCCSV: urljoin(BASE_URL, api_v1, `/policy/___administrator/gmc/report/csv`),
        GET_GMCPDF: urljoin(BASE_URL, api_v1, `/policy/___administrator/gmc/report/pdf`),
        MHW_SCHEME: urljoin(BASE_URL,api_v1,`group_scheme/mutual-help-welfare`)
    }
}